<template>
  <apexchart height="300" type="donut" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  data() {
    return {
      series: [],
      chartOptions: {
        labels: [],
        chart: {
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
            },
          },
        ],
      },
    };
  },

  computed: {
    incidentStatistics() {
      return this.$store.getters["socket/incident"].statistics;
    },
  },

  methods: {
    async generateChartData() {
      let violationData = cloneDeep(this.incidentStatistics.vehicleClassWiseData);
      let filteredData = [];
      if (violationData) {
        violationData.forEach(function (a) {
          let index;
          if (
            filteredData.some(function (c, i) {
              index = i;
              return a.class_name == c.class_name;
            })
          ) {
            filteredData[index].count += a.count;
          } else {
            filteredData.push(a);
          }
        });
      }

      for (let i of filteredData) {
        if (this.chartOptions.labels.indexOf(i.class_name) === -1) {
          this.series.push(i.count);
          this.chartOptions.labels.push(i.class_name);
        }
      }
    },
  },

  mounted() {
    this.generateChartData();
  },
};
</script>
